module.exports = "/_next/static/images/be4d09b07ea101421121dd4f6157412c-notaxes@1x.jpg";